import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Teodor Sandu
 * id 8C3A8BC3-9144-4D24-A41D-BBE2B557BF51
 * name curtains
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/curtains.svg
 * tags
 * - Home Automation 
 */
export const CurtainsIcon = createSvgIcon(<><path d="M23 3H1V1H23V3M2 22H6C6 19 4 17 4 17C10 13 11 4 11 4H2V22M22 4H13C13 4 14 13 20 17C20 17 18 19 18 22H22V4Z" /></>, 'CurtainsIcon');
export default CurtainsIcon